var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtfwd60(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.17 16.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: white;\n        stroke-miterlimit: 10;\n        stroke-width: 1px;\n      }\n\n      .cls-2 {\n        fill: white;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m8.93,5.27c-.22-.01-.49,0-.79.05-1.65.28-2.53,1.49-2.71,2.77h.04c.37-.49,1.02-.9,1.88-.9,1.38,0,2.35,1,2.35,2.52,0,1.43-.97,2.75-2.59,2.75s-2.76-1.3-2.76-3.32c0-1.54.55-2.75,1.32-3.51.65-.64,1.51-1.03,2.5-1.15.31-.05.58-.06.77-.06v.86Zm-.3,4.5c0-1.12-.64-1.79-1.61-1.79-.64,0-1.22.4-1.51.96-.07.12-.12.28-.12.47.02,1.28.61,2.23,1.71,2.23.91,0,1.52-.76,1.52-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.82,8.34c0,2.65-.98,4.11-2.71,4.11-1.52,0-2.55-1.43-2.58-4.01,0-2.61,1.13-4.05,2.71-4.05s2.58,1.46,2.58,3.95Zm-4.23.12c0,2.03.62,3.18,1.58,3.18,1.08,0,1.59-1.26,1.59-3.25s-.49-3.18-1.58-3.18c-.92,0-1.59,1.13-1.59,3.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.17,1.32H4.41c-2.3,0-4.16,2.13-4.16,4.75v5.33c0,2.62,1.86,4.75,4.16,4.75h12.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.04,
    y1: 1.32,
    x2: 12.96,
    y2: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.04,
    y1: 1.32,
    x2: 12.96,
    y2: 2.41
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtfwd60);
export default __webpack_public_path__ + "static/media/btfwd60.ff214fd2d6618b9116c0bdc72e979ecf.svg";
export { ForwardRef as ReactComponent };